import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ButtonModule } from '@components/button';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { EventLoggerService } from '@services/event-logger-service';

export const PAYMENT_OPTION = {
  COD_FEE: 'cod_fee',
  FULL_PAYMENT: 'full_payment',
} as const;

export type PaymentOption = typeof PAYMENT_OPTION[keyof typeof PAYMENT_OPTION];

@Component({
  selector: 'share-payment-link-generated',
  templateUrl: './share-payment-link-generated.html',
  imports: [CommonModule, ButtonModule, ButtonCtaComponent],
})
export class SharePaymentLinkGeneratedComponent {
  data = inject<any>(MAT_BOTTOM_SHEET_DATA);
  private readonly bottomSheetRef = inject(MatBottomSheetRef);
  private readonly eventLogger = inject(EventLoggerService);

  readonly PAYMENT_OPTION = PAYMENT_OPTION;
  selectedOption: PaymentOption = PAYMENT_OPTION.FULL_PAYMENT;
  orderSP: number = 0;
  codFee: number = 0;

  ngOnInit(): void {
    this.orderSP = this.data?.orderSP || 0;
    this.codFee = this.data?.codFee || 0;
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'payment_link_generated_shown' }));
  }

  get selectedAmount(): number {
    return this.selectedOption === PAYMENT_OPTION.COD_FEE ? this.codFee : this.orderSP;
  }

  get remainingAmount(): number {
    return this.orderSP - this.codFee;
  }

  selectOption(option: PaymentOption): void {
    this.selectedOption = option;
    this.eventLogger.cleverTapEvent('click', JSON.stringify({
      name: option === PAYMENT_OPTION.COD_FEE ? 'payment_link_cod_fee_selected' : 'payment_link_full_payment_selected',
    }));
  }

  onShareLink(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({
      name: 'share_payment_link_cta_clicked',
      selectedOption: this.selectedOption,
    }));
    this.bottomSheetRef.dismiss();
    if (this.data?.onShare) {
      this.data.onShare(this.selectedOption === PAYMENT_OPTION.COD_FEE);
    }
  }

  closeBottomSheet(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'payment_link_generated_closed' }));
    this.bottomSheetRef.dismiss();
  }
}
